<template>
  <div class="shareholder">
    <div style="height: 10px"></div>
    <TableView :data="data" :columns="columns" :pagination="false">
      <template v-slot:action="{ tableRow, index }">
        <div>
          <a-button type="link" size="small" @click="handleEdit(tableRow)">
            编辑
          </a-button>
          <a-divider type="vertical" />
          <a-popconfirm
            title="是否删除该数据账期?"
            @confirm="handleDeleteConfirm(tableRow)"
            v-if="num == 0 || index >= num"
          >
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a-button type="link" size="small">删除</a-button>
          </a-popconfirm>
        </div>
      </template>
    </TableView>

    <div>
      <a-button class="width-100" icon="plus" type="dashed" @click="add">
        新增账期
      </a-button>
    </div>
    <card-edit ref="applyCardEdit">
      <a-modal
        v-model="visible"
        destroyOnClose
        @ok="handleSubmit"
        :title="modalTitle"
        :maskClosable="false"
        :afterClose="handleAfterClose"
      >
        <a-form :form="modalForm">
          <a-form-item label="业务类型">
            <a-select
              v-decorator="['business']"
              @focus="handleBgFocus"
              @change="changeBusiType"
            >
              <a-select-option
                v-for="item in businessList"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="业务模式">
            <a-select v-decorator="['model']" @focus="handleModelFocus">
              <a-select-option
                v-for="optionItem in modelOptionList"
                :value="optionItem.id"
                :key="optionItem.id"
                :disabled="optionItem.disabled"
              >
              {{ optionItem.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Segment">
            <a-select
              v-decorator="['segmentId']"
              @focus="handleSegmentFocus"
              @change="handleSegmentChange"
            >
              <a-select-option
                v-for="item in segmentOptionList"
                :value="item.id"
                :key="item.id"
              >
              {{ item.segmentLevel }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="账期(天)">
            <a-input
              v-decorator="['term']"
              type="text"
              :maxLength="3"
              oninput="value=value.replace(/[^\d]/g,'')"
            ></a-input>
          </a-form-item>
        </a-form>
      </a-modal>
    </card-edit>
  </div>
</template>
<script>
import { CardEdit } from 'lxfintech-fe'
import { TableView } from 'lxfintech-fe'
import mixin from './mixinContact'
import { getBusinessList, selectLevel, getRegionList, getFreezeModelList, getSegmentLevelList,
  getFreezeSegmentList, getFreezeBgList, selectName, getSegmentList, getPeriodist } from './api'
// getSegmentList, selectName
const data = [],
  MODEL_TYPE = 3

export default {
  mixins: [mixin],
  name: 'ContactInfo',
  props: ['customerDetail', 'groupCode', 'typeOperate'],
  data() {
    return {
      modalForm: this.$form.createForm(this),
      data,
      modalTitle: '新增',
      visible: false,
      disabled: false,
      nameValue: '',
      businessList: [],
      segmentList: [], //Sg冻结
      segmentOptionList: [], //segment列表
      businessName: '',
      segmentLevel: '',
      type11: '',
      bgList: [],
      Model_Name: '',
      num: '',
      modelOptionList: [], // 业务模式列表
      model: '',
      periodBo: true,
    }
  },
  components: {
    CardEdit,
    TableView,
  },
  mounted() {
    this._getbgList()
    this.query()
  },
  methods: {
    //业务模式禁用
    handleModelFocus() {
      if (this.modelOptionList) {
        this.modelOptionList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.modelList) {
        this.modelOptionList.forEach(item => {
          this.modelList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //刷新组件
      }
    },
    //业务类型禁用
    handleBgFocus() {
      if (this.businessList) {
        this.businessList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.syList) {
        this.businessList.forEach(item => {
          this.syList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //一定要刷新组件！！！！！！！！！！！！
      }
    },
    //Segment禁用
    handleSegmentFocus() {
      if (this.segmentOptionList) {
        this.segmentOptionList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.segmentList) {
        this.segmentOptionList.forEach(item => {
          this.segmentList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //刷新组件
      }
    },
    handleSegmentChange(value) {
      this.getLevel(value)
      this.segmentOptionList.forEach(item => {
        if (item.id === value) {
          this.$refs.applyCardEdit.setFormFieldsValue('link', item.link)
        } else if (value === '0') {
          this.$refs.applyCardEdit.setFormFieldsValue('link', '1')
        } else {
          console.log('item')
          console.log(item)
        }
      })
    },
    async query() {
      this.data = this.customerDetail
      if (this.data.length == 0 && this.num == '') {
        this.num = 0
      } else if (this.num == '') {
        this.num = this.data.length
      }
    },
    //获取业务类型下拉选
    async _getbgList() {
      try {
        const { data } = await getBusinessList()
        this.businessList = data
        this._getFreezeBgList()
        this.loading = false
      } catch (error) {
        console.error(error)
      }
      // getBgList().then(({ data }) => {
      //   this.bgList = data
      // })
    },
    _getFreezeBgList() {
      getFreezeBgList().then(({ data }) => {
        this.syList = data
      })
    },
    // 取消弹框
    handleAfterClose() {
      this.id = null
      this.modalTitle = '新增'
    },
    //获取business的name
    async getName(business) {
      this.modalForm.setFieldsValue({ segmentId: '' })
      selectName(business).then(({ data }) => {
        this.businessName = data
      })
      //根据BG查Segment
      getSegmentList(business).then(({ data }) => {
        data.unshift({
          id: '0',
          segmentLevel: 'ALL',
          link: '1',
        })
        this.segmentOptionList = data
      })
    },
    changeBusiType(value) {
      this.getName(value)
      this.modalForm.setFieldsValue({ segmentId: '', model: '' })
      this.getSegmentLevelLists(value)
      this.$refs.applyCardEdit.setFormFieldsValue('segmentId', '')
      ;[MODEL_TYPE].forEach(type => {
        this.fetchRegionList(value, type)
      })
    },
    //获取segment的level
    async getLevel(segment) {
      if (segment == 0) {
        this.segmentLevel = 'ALL'
      } else {
        selectLevel(segment).then(({ data }) => {
          if (data == null) {
            this.segmentLevel = []
          }
          this.segmentLevel = data
        })
      }
    },
    async getSegmentLevelLists(value) {
      try {
        const { data } = await getSegmentLevelList({ business: value })
        data.unshift({
          id: '0',
          segmentLevel: 'ALL',
          link: '1',
        })
        this.segmentOptionList = data
        this.__getFreezeSegmentList()
      } catch (error) {
        console.error(error)
      }
    },
    __getFreezeSegmentList() {
      getFreezeSegmentList().then(({ data }) => {
        this.segmentList = data
      })
    },
    async fetchRegionList(pid, type) {
      try {
        const { data } = await getRegionList({ pid, type })
        this.setOptionListByType(type, data)
      } catch (error) {
        console.error(error)
      }
    },
    async setOptionListByType(type, data) {
      switch (type) {
        case MODEL_TYPE:
          this.modelOptionList = data
          this._getFreezeModelList()
          return
      }
    },
    _getFreezeModelList() {
      getFreezeModelList().then(({ data }) => {
        this.modelList = data
      })
    },
    // 提交
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          this.type11 = '1'
          if (!this.id) {
            this.type11 = '0'
            this.id = new Date().getTime()
          }
          try {
            const submitData = {
              ...values,
              id: this.id,
              code: this.groupCode,
              name: this.businessName,
              segment: this.segmentLevel,
            }
            if (this.type11 == '0') {
              for (let i = 0; i < this.data.length; i++) {
                const business = this.data[i].business
                const segmentId = this.data[i].segmentId
                if (
                  business == submitData.business && (segmentId == submitData.segmentId || 
                  (segmentId == 0 && submitData.segmentId != '' && submitData.segmentId != undefined) 
                  || (segmentId != '' && segmentId != undefined && submitData.segmentId == 0 ))
                ) {
                  this.visible = false
                  return this.$message.error('BG+Segment账期已存在！')
                }
              }
              const periodData = {
                term: submitData.term,
              }

              const { data } = await getPeriodist(periodData)
              this.periodBo = data.aboolean

              if (this.periodBo == true) {
                this.data.push(submitData)
                this.visible = false
              } else if (this.periodBo == false) {
                this.$confirm({
                  title: '提示',
                  content: '该账期非标准账期，是否继续?',
                  okButtonProps: {
                    loading: this.loading,
                  },
                  cancelText: '否',
                  okText: '是',
                  onOk: () => {
                    this.loading = true
                    this.data.push(submitData)
                    this.visible = false
                  },
                  onCancel: () => {
                    this.loading = true
                    this.visible = false
                  }
                })
              }
            } else {
              for (let i = 0; i < this.data.length; i++) {
                const business = this.data[i].business
                const segmentId = this.data[i].segmentId
                const id = this.data[i].id
                if (
                  business == submitData.business && id != submitData.id &&
                  (segmentId == submitData.segmentId || 
                  (segmentId == 0 && submitData.segmentId != '' && submitData.segmentId != undefined) 
                  || (segmentId != '' && segmentId != undefined && submitData.segmentId == 0))
                ) {
                  // this.visible = false
                  return this.$message.error('BG+Segment账期已存在！')
                }
              }
              this.getName(submitData.business)
              if (submitData.segmentId != null && submitData.segmentId != '') {
                this.getLevel(submitData.segmentId)
              }

              const periodData = {
                term: submitData.term,
              }
              const { data } = await getPeriodist(periodData)
              this.periodBo = data.aboolean

              if (this.periodBo == true) {
                this.data.forEach(element => {
                  if (element.id == submitData.id) {
                    element.business = submitData.business
                    element.model = submitData.model
                    element.segmentId = submitData.segmentId
                    element.term = submitData.term
                    element.name = submitData.name
                    if (submitData.segmentId == '') {
                      element.segment = ''
                    } else {
                      element.segment = submitData.segment
                    }
                  }
                })
                this.visible = false
              } else if (this.periodBo == false) {
                this.$confirm({
                  title: '提示',
                  content: '该账期非标准账期，是否继续?',
                  okButtonProps: {
                    loading: this.loading,
                  },
                  cancelText: '否',
                  okText: '是',
                  onOk: () => {
                    this.loading = true
                    this.data.forEach(element => {
                      if (element.id == submitData.id) {
                        element.business = submitData.business
                        element.model = submitData.model
                        element.segmentId = submitData.segmentId
                        element.term = submitData.term
                        element.name = submitData.name
                        if (submitData.segmentId == '') {
                          element.segment = ''
                        } else {
                          element.segment = submitData.segment
                        }
                      }
                    })
                    this.visible = false
                  },
                  onCancel: () => {
                    this.loading = true
                    this.visible = false
                  }
                })
              }
            }
            this.query()
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    
    //删除
    async handleDeleteConfirm({ id }) {
      try {
        this.data.forEach((element, index) => {
          if (element.id == id) {
            this.data.splice(index, 1)
          }
        })
        this.$notification.success({
          message: '提示',
        })
        this.query()
      } catch (error) {
        console.log(error)
      }
    },
    //修改
    async handleEdit({ business, segmentId, term, id, name, segment, model }) {
      this.modalTitle = '编辑'
      this.modalTitle === '编辑'
        ? (this.disabled = true)
        : (this.disabled = false)
      if (business != null) {
        this.getName(business)
        this.changeBusiType(business)
      }
      setTimeout(() => {
        this.$nextTick(() => {
          this.modalForm.setFieldsValue({
            business,
            segmentId,
            term,
            model,
          })
        })
        this.id = id
        this.businessName = name
        this.segmentLevel = segment
      }, 20)
      this.visible = true
    },
    //新增
    add() {
      this.modalForm.resetFields()
      this.disabled = true
      this.visible = true
      this.businessName = ''
      this.segmentLevel = ''
    },
  },
}
</script>
<style lang="less" scoped>
.shareholder {
  /deep/ .margin-left-20 {
    margin-left: 20px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  /deep/ .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  /deep/.margin-bottom-20 {
    margin-bottom: 20px;
  }
  /deep/ .editable-row-operations a {
    margin-right: 8px;
  }
  /deep/ .shareholder-add-btn {
    margin-top: 20px;
    .editable-add-btn {
      width: 100%;
    }
  }
}
/deep/ .editable-row-operations a {
  margin-right: 8px;
}
/deep/ .margin-top-20 {
  margin-top: 20px;
}
/deep/ .width-100 {
  width: 100%;
}
</style>
